<template>
  <user-base>
    <router-view></router-view>
  </user-base>
</template>

<script>
import UserBase from "@/views/User/Common/UserBase";
export default {
  name: "UserService",
  components: {UserBase},
}
</script>
